angular.module('gym.bulkImports').directive('bulkImportMapColums', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/bulkImports/show/bulkImportMapColums.html.slim'),
    scope: {
      bulkImport: '=',
      meta: '=',
      loading: '=',
      locked: '=',
      cancel: '&',
      next: '&'
    },
    controller: ["$scope", "$q", "AllForms", "flash", function($scope, $q, AllForms, flash) {
      var save;
      $scope.columns = $scope.bulkImport.all('columns').getList({
        count: 1000
      }).$object;
      $scope.humanizedColumns = $scope.meta.accepted_columns[$scope.bulkImport.import_type].map(function(column) {
        return [column, $scope.meta.humanized_accepted_columns[$scope.bulkImport.import_type][column]];
      });
      if ($scope.bulkImport.import_type === 'contact') {
        $scope.humanizedColumns.push([null, 'Other (custom field)']);
      }
      AllForms.getList().then(function(data) {
        var fields;
        fields = data.plain().map(function(form) {
          return form.fields.map(function(field) {
            field.group = form.label;
            return field;
          });
        });
        return $scope.fields = _.flatten(fields).filter(function(field) {
          return !field.system;
        });
      });
      $scope.change = function(column) {
        if (column.mapped_to_form_field_id) {
          column.mapped_to_field_name = null;
        }
        column.confirmed = false;
        return column.ignored = false;
      };
      save = function(column) {
        var deferred;
        deferred = $q.defer();
        column.errors = {};
        column.isLoading = true;
        column.rootObjectName = 'bulk_import_column';
        column.save().then(function(data) {
          angular.extend(column, data.plain());
          deferred.resolve();
          return column.isLoading = false;
        }, function(response) {
          column.isLoading = false;
          column.confirmed = false;
          column.errors = response.data.errors;
          return deferred.reject();
        });
        return deferred.promise;
      };
      $scope.onColumnFieldChange = function(column) {
        if (column.mapped_to_field_name) {
          column.field_type = 'table_and_column';
          return column.mapped_to_form_field_id = null;
        } else {
          return column.field_type = 'form_field';
        }
      };
      $scope.confirmReady = function(column) {
        return !column.isLoading && (column.mapped_to_field_name || column.mapped_to_form_field_id);
      };
      $scope.confirm = function(column) {
        column.confirmed = true;
        if (!column.field_type) {
          column.field_type = 'table_and_column';
        }
        return save(column);
      };
      $scope.submit = function() {
        var promises;
        promises = $scope.columns.filter(function(item) {
          return !item.confirmed && $scope.confirmReady(item);
        }).map($scope.confirm);
        $scope.columnsSaving = true;
        return $q.all(promises).then(function() {
          $scope.columnsSaving = false;
          return $scope.next();
        }, function() {
          flash.error = 'Not all columns are mapped yet. Please finish mapping and try again.';
          return $scope.columnsSaving = false;
        });
      };
      $scope.ignore = function(column) {
        column.ignored = true;
        column.confirmed = true;
        return save(column);
      };
      $scope.mappedColumnLabel = function(column) {
        if (column.field_type === 'table_and_column') {
          return column.mapped_to_field_name_humanized;
        } else {
          return column.mapped_to_form_field_label;
        }
      };
      $scope.isReady = function() {
        return !$scope.columnsSaving && !$scope.loading && !_.find($scope.columns, function(column) {
          return !_.isEmpty(column.errors);
        });
      };
      return $scope.cancelImport = function() {
        return $scope.cancel();
      };
    }]
  };
});
